import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

declare global {
  interface Logger {
    ok(message: string, messageContext?: object, error?: Error): void;
    debug(message: string, messageContext?: object, error?: Error): void;
    info(message: string, messageContext?: object, error?: Error): void;
    notice(message: string, messageContext?: object, error?: Error): void;
    warn(message: string, messageContext?: object, error?: Error): void;
    error(message: string, messageContext?: object, error?: Error): void;
    critical(message: string, messageContext?: object, error?: Error): void;
    alert(message: string, messageContext?: object, error?: Error): void;
    emerg(message: string, messageContext?: object, error?: Error): void;
  }

  interface Window {
    DD_LOGS: {
      logger: Logger;
    };
  }
}

export enum LOG_TYPE {
  error = "error",
  warn = "warn",
  info = "info",
}

export const logger = () => {
  return window.DD_LOGS ? window.DD_LOGS.logger : undefined;
};

const isSuccessfulResponse = (responseStatus: number) => {
  return responseStatus >= 200 && responseStatus < 300;
};

export const createRequestLog = (req: AxiosRequestConfig) => {
  process.env.NODE_ENV === "production" &&
    logger()?.info(`Request: ${req.method?.toUpperCase()} ${req.url}`, {
      request: {
        URL: req.url,
        method: req.method,
      },
    });
};

export const createResponseLog = (res: AxiosResponse) => {
  process.env.NODE_ENV === "production" &&
    logger()?.[
      isSuccessfulResponse(res.status) ? LOG_TYPE.info : LOG_TYPE.error
    ](
      `Response: ${res.config.method?.toUpperCase()} ${
        res.config.url
      } Status: ${res.status}`,
      {
        response: {
          URL: res.config.url,
          status: res.status,
          method: res.config.method,
        },
      }
    );
};

export const createResponseErrorLog = (error: AxiosError) => {
  if (!error || !error.config) return;

  process.env.NODE_ENV === "production" &&
    logger()?.error(
      `Response: ${error.config.method?.toUpperCase()} ${
        error.config.url
      } Status: ${error.response?.status}`,
      {
        error: {
          URL: error.config.url,
          status: error.response?.status,
          method: error.config.method,
        },
      }
    );
};
